import React, { useState } from "react";
import { useNavigate } from "react-router";
import { AddLocalStorageData, GetLocalStorageData } from "../Helpers/Utilities";
import {useParams } from 'react-router-dom';
const SaveAndNavigate = (props) => {
  const navigate = useNavigate();
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  let patientData = GetLocalStorageData("patient")
  patientData = patientData && JSON.parse(patientData);
  const { lot } = useParams();
  
  const locked = patientData?.locked ?? false;
  //const isEligible = props?.isEligible??true;



  //Validate and save
  const HandlePreviousClick = async () => {
    if(props.paths.currPage === "/PatientScreening" ){
      navigate(props.paths.prevPage);
    }
    if (props.paths.prevPage === "/Introduction") {
      if(!locked)
        await props.Save(true);
      navigate(props.paths.prevPage);
    }
    
    else
      if (locked || await props.Save(true)) {
        navigate(props.paths.prevPage);
      }
    window.scrollTo(0, 0);
    //LoadConfig()
  }
  //Validate and save
  const HandleNextClick = async () => {
    if (locked || await props.Save(true)) {
      navigate(props.paths.nextPage);
    }

    else if (props.paths.currPage === "/EligibilityCriteria"){
      navigate(props.paths.nextPage);
    }
    else if (props.paths.currPage === "/PatientScreening"){
        navigate(props.paths.nextPage);
    }
    window.scrollTo(0, 0);
    //LoadConfig()
  };
  //save without validating
  const HandleSaveClick = async () => {
    locked || await props.Save(false)
    window.scrollTo(0, 0);
    LoadConfig()
  }
  //Validate and save
  const HandleSubmitClick = async () => {
    locked || await props.Save(true)
    window.scrollTo(0, 0);
    LoadConfig()
  }
  const LoadConfig = () => {
    AddLocalStorageData("loadConfig", true)
  }

  return (
    <>
      {props.paths.prevPage &&  (
        <a onClick={HandlePreviousClick}>
          <img
            className="previous-btn-padding"
            src="../Assets/images/previous.png"
            alt=""
          />
        </a>
      )}
      {/* {(props.paths.currPage !== "/PatientScreening" && props.paths.currPage !== "/Introduction") && */}
      {props.paths.currPage !== "/EligibilityCriteria" && props.paths.currPage !== "/PatientScreening"  && (
        <a
          className="btn save-btn"
          onClick={HandleSaveClick}
          style={{ fontWeight: "600", fontSize: "large", marginRight: "20px" }}
        >
          Save
        </a>
      )}
      {/* } */}
      {(props.paths.currPage !== "/EligibilityCriteria" && props.paths.currPage !== "/TreatmentsPriorEpcoritamab" && props.paths.currPage !== "/TreatmentsAfterEpcoritamab" ) && (
      <a
        className="btn save-btn"
        onClick={HandleSubmitClick}
        style={{ fontWeight: "600", fontSize: "large" }}
      >
        Submit
      </a>
         )}
      {props.paths.nextPage && (
        <a onClick={HandleNextClick}>
          <img
            className="next-btn-padding"
            src="../Assets/images/next.png"
            alt=""
          />
        </a>
      )}
    </>
  );
};

export default SaveAndNavigate;